import api from './api';
import { Repository, CreateRepositoryRequest, UpdateRepositoryRequest } from '../types';

export const repositoryService = {
  getAll: async (projectId?: number): Promise<Repository[]> => {
    const response = await api.get('/repositories', {
      params: projectId !== undefined ? { projectId } : {},
    });
    return response.data;
  },

  getById: async (id: number): Promise<Repository> => {
    const response = await api.get(`/repositories/${id}`);
    return response.data;
  },

  create: async (data: CreateRepositoryRequest): Promise<Repository> => {
    const response = await api.post('/repositories', data);
    return response.data;
  },

  update: async (id: number, data: UpdateRepositoryRequest): Promise<Repository> => {
    const response = await api.put(`/repositories/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/repositories/${id}`);
  },
};

export default repositoryService;
